<div class="">

<div class="flex align-items-center mt-3" style="width: 100%;">

    <div style="flex: 1;"></div>

    <div class="flex align-items-center justify-content-center" style="flex: 1;">
        <span class="p-input-icon-left">
            <i class="pi pi-search"></i>  
            <input
                pInputText
                type="text"
                [(ngModel)]="searchKey"
                [placeholder]="placeholder"
                class="p-inputtext-sm"
                (keyup.enter)="searchAccount()"
                style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
        </span>

        <p-button
            icon="pi pi-search"
            (onClick)="searchAccount()"
            class="ml-2"
            size="small"
            severity="info"
            [raised]="true">
        </p-button>
    </div>

    <div class="flex justify-content-end" style="flex: 1;">
        <p-button
            icon="pi pi-refresh"
            size="small"
            (click)="refreshData()"
            [rounded]="true"
            severity="info">
        </p-button>
    </div>

</div>


    <p-table #dt1 [value]="result.account" [scrollable]="true" scrollHeight="350px" styleClass="p-datatable-striped"
        responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="10"
        paginatorDropdownAppendTo="body" (onPage)="loadAccounts($event)" (onRowSelect)="SelectOption($event)"
        [rowsPerPageOptions]="[10,15,20]">


        <ng-template pTemplate="header">
            <tr>
                <th>
                </th>
                <th>Account Code</th>
                <th>Account Name</th>
                <th>Account Type </th>
                <th>Account Group </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-Account>
            <tr (click)="SelectOption(Account)">
                <td><p-tableRadioButton [value]="Account"></p-tableRadioButton></td>
                <td>{{Account.accountCode}}</td>
                <td>{{Account.accountName}}</td>
                <td>{{Account.accountTypes?.accountType}}</td>
                <td>{{Account.accountGroup?.accountGroupName}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8">No Records found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>